<div [class]="containerClasses">
  <i class="vb-search__icon pi pi-search"></i>
  <input
    type="text"
    class="vb-search__input"
    [placeholder]="translatedPlaceholder"
    [disabled]="disabled"
    [value]="value"
    (input)="onInputChange($event)"
  />
  @if (showClearButton && value) {
    <i
      class="vb-search__clear pi pi-times"
      (click)="onClear()"
      role="button"
      tabindex="0"
      (keydown.enter)="onClear()"
      (keydown.space)="onClear()"
    ></i>
  }
</div>
